export default __webpack_public_path__ + "static/media/driver_color.67e567fa.svg";